import { useInitData, useUserData } from '../../../hooks'
import { CustomLink } from '../../CustomLink'

import { getCompanyHomePageLink } from './CompanyLink.utils'

import * as styles from './CompanyLink.module.css'

function CompanyLink({ children, className = styles.CompanyLink }) {
  const { availableSections } = useInitData()
  const userData = useUserData()

  const toLink = getCompanyHomePageLink({
    availableSections,
    userData,
  })

  return (
    <CustomLink className={className} to={toLink}>
      {children}
    </CustomLink>
  )
}

export default CompanyLink
